<template>
  <v-container>
    <v-row justify="center">
      <v-img
        v-if="userInfo.icon"
        class="user-profile"
        :src="userInfo.icon"
        max-width="200"
        max-height="200"
      />
      <v-icon
        v-else
        class="user-profile-placeholder"
        size="100"
      >
        fa-user
      </v-icon>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        sm="10"
      >
        <v-text-field
          id="editEmail"
          v-model="userInfo.login_id"
          :label="$t('edit.email')"
          :error="error.length ? (error.login_id.length && true) : false"
          :error-messages="error.login_id"
        />
      </v-col>

      <v-col
        cols="12"
        sm="2"
      >
        <v-select
          id="editStatus"
          v-model="userInfo.status"
          :items="statusList"
          item-text="text"
          item-value="value"
          :label="$t('general.status')"
          :error="error.length ? (error.status.length && true) : false"
          :error-messages="error.status"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        sm="5"
      >
        <v-text-field
          id="editName"
          v-model="userInfo.name"
          :label="$t('general.name')"
          :error="error.length ? (error.name.length && true) : false"
          :error-messages="error.name"
        />
      </v-col>

      <v-col
        cols="12"
        sm="5"
      >
        <v-text-field
          id="editTel"
          v-model="userInfo.tel"
          :label="$t('general.tel')"
          :error="error.length ? (error.tel.length && true) : false"
          :error-messages="error.tel"
        />
      </v-col>

      <v-col
        cols="12"
        sm="2"
      >
        <v-select
          id="editUserType"
          v-model="userInfo.user_type"
          :items="userTypeList"
          item-text="text"
          item-value="value"
          :label="$t('general.userType')"
          :error="error.length ? (error.user_type.length && true) : false"
          :error-messages="error.user_type"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col
        v-if="userInfo.id"
        cols="12"
        sm="5"
      >
        <v-text-field
          id="editJoinDate"
          v-model="userInfo.created_at"
          :label="$t('general.joinDate')"
          disabled
          readonly
        />
      </v-col>

      <v-col
        v-if="!userInfo.id"
        cols="12"
        sm="5"
      >
        <v-text-field
          id="editPassword"
          v-model="userInfo.password"
          :label="$t('general.password')"
          :error="error.length ? (error.password.length && true) : false"
          :error-messages="error.password"
          type="password"
        />
      </v-col>

      <v-col
        cols="12"
        sm="5"
      >
        <v-dialog
          ref="birthdayDialog"
          v-model="showBirthdayPicker"
          :return-value.sync="userInfo.birthday"
          persistent
          width="320px"
        >
          <template #activator="{ on, attrs }">
            <v-text-field
              v-model="userInfo.birthday"
              :label="$t('general.birthday')"
              readonly
              clearable
              v-bind="attrs"
              v-on="on"
            />
          </template>
          <v-date-picker
            v-model="userInfo.birthday"
            :locale="convertLocale(currentLocale, 'bcp47')"
            scrollable
            @input="setDate(userInfo.birthday, 'birthdayDialog', showBirthdayPicker)"
          />
        </v-dialog>
      </v-col>

      <v-col
        cols="12"
        sm="2"
      >
        <v-select
          id="editGender"
          v-model="userInfo.gender"
          :items="genderList"
          item-text="text"
          item-value="value"
          :label="$t('general.gender')"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-spacer />
      <v-btn
        class="ma-3"
        color="secondary"
        @click="back()"
      >
        {{ $t('common.back') }}
      </v-btn>
      <v-btn
        v-if="userInfo.id"
        class="ma-3"
        color="error"
        @click="del()"
      >
        {{ $t('common.delete') }}
      </v-btn>
      <v-btn
        class="ma-3"
        color="success"
        @click="edit()"
      >
        {{ $t('common.save') }}
      </v-btn>
    </v-row>
  </v-container>
</template>

<i18n src="./locales/en.json"></i18n>
<i18n src="./locales/zhHant.json"></i18n>

<script>
import ErrorDisplay from '@/components/functions/Common/mixins/ErrorDisplay'
import SysUtils from '@/base/utils/SysUtils'
import moment from 'moment'

export default {
  name: 'UserEdit',
  mixins: [ErrorDisplay],
  props: {
    userDetails: {
      type: Object,
      default: () => { return {} }
    },
    validation: {
      type: Object,
      default: () => { return {} }
    }
  },
  data: function () {
    return {
      userInfo: {},
      error: {},
      showBirthdayPicker: false,
      userTypeList: [
        { value: 'usr', text: this.$t('general.user') },
        { value: 'adm', text: this.$t('general.admin') }
      ],
      statusList: [
        { value: 0, text: this.$t('general.inactive') },
        { value: 1, text: this.$t('general.active') },
        { value: -1, text: this.$t('general.banned') }
      ],
      genderList: [
        { value: 0, text: this.$t('general.male') },
        { value: 1, text: this.$t('general.female') }
      ]
    }
  },
  watch: {
    userDetails: {
      deep: true,
      handler (val) {
        if (val) this.userInfo = JSON.parse(JSON.stringify(val))
        this.userInfo.created_at = this.formatDate(this.userInfo.created_at)
      }
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {
      this.userInfo = {
        id: null,
        login_id: null,
        status: null,
        name: null,
        tel: null,
        user_type: null,
        created_at: null,
        password: null,
        birthday: null,
        gender: null,
        icon: null
      }
      this.error = {}
    },
    back () {
      this.init()
      this.$emit('back')
    },
    edit () {
      this.error = {}
      SysUtils.validate(this.userInfo, this.validation)
        .then(validated => {
          if (validated.valid) {
            this.$emit('edit', JSON.parse(JSON.stringify(this.userInfo)))
          } else {
            this.error = validated.results
          }
        })
    },
    del () {
      this.$emit('del', JSON.parse(JSON.stringify(this.userInfo)))
    },
    formatDate (createdAt) {
      moment.locale(this.convertLocale(this.currentLocale, 'bcp47'))
      if (moment(createdAt).isValid()) return moment(createdAt).format('LLL')
      return null
    },
    setDate (date, ref, modal) {
      this.$refs[ref].save(date)
      modal = false
    }
  }
}
</script>

<style scoped>
.user-profile, .user-profile-placeholder{
  border: 5px solid var(--v-primary-base);
}

.user-profile-placeholder{
  width: 180px;
  height: 180px;
}
</style>
